import 'dayjs/locale/de';
import 'dayjs/locale/en';
import 'dayjs/locale/es';
import 'dayjs/locale/fr';
import 'dayjs/locale/it';
import 'dayjs/locale/nl';
import 'dayjs/locale/pt';
import enUS from 'date-fns/locale/en-US';
import de from 'date-fns/locale/de';
import fr from 'date-fns/locale/fr';
import es from 'date-fns/locale/es';
import it from 'date-fns/locale/it';
import nl from 'date-fns/locale/nl';
import pt from 'date-fns/locale/pt';

export const getLocale = () => {
    const locale = navigator.language;

    if (localStorage.getItem('languageSet')) {
        const shortName = localStorage.getItem('languageSet') as string;

        switch (shortName) { case 'english': return 'en'; case 'german': return 'de'; case 'french': return 'fr'; case 'spanish': return 'es'; case 'italian': return 'it'; case 'dutch': return 'nl'; case 'portuguese': return 'pt'; default: return 'en'; }
    }

    return locale;
};

export const convertLocale = () => {
    const shortName = getLocale();

    const languageCode = shortName.split(/[-_]/)[0]; // Extracts the language code

    switch (languageCode) { case 'en': return enUS; case 'de': return de; case 'fr': return fr; case 'es': return es; case 'it': return it; case 'nl': return nl; case 'pt': return pt; default: return enUS; }
};
